
import { defineComponent, PropType } from 'vue';
import { SelectedCourse } from '../../types';
import TimetableSelectedCourseCard from './components/TimetableSelectedCourseCard.vue';

export default defineComponent({
  components: {
    TimetableSelectedCourseCard,
  },
  props: {
    courses: { type: Array as PropType<SelectedCourse[]>, required: true },
  },
  emits: ['click-cloud', 'click-back', 'delete-course', 'show-detail'],
  data() {
    return {
      /** 同步冷却 */
      cooldownCnt: 0,
    };
  },
  methods: {
    /** 点击云 */
    handleClickCloud() {
      if (this.cooldownCnt > 0) {
        this.$message.warn(`请等待${this.cooldownCnt}秒再进行下一次云同步~`);
        return;
      }
      const cooldown = () => {
        setTimeout(() => {
          this.cooldownCnt -= 1;
          if (this.cooldownCnt > 0) {
            cooldown();
          }
        }, 1000);
      };

      this.cooldownCnt = 60;
      cooldown();
      this.$emit('click-cloud');
    },
    /** 点击卡片 */
    handleClickCard() {
      // TODO: 待后端传入 lectureId 后跳转至评课页
    },
  },
});
